import gql from 'graphql-tag';

const SET_HASHED_EMAIL_LIST_AUTO_REFRESH = gql`
  mutation setHashedEmailListAutoRefresh($id: ID!, $orgID: ID!, $autoRefresh: Boolean!) {
    setHashedEmailListAutoRefresh(
      data: { id: $id, orgID: $orgID, autoRefresh: $autoRefresh }
    )
  }
`;

export default SET_HASHED_EMAIL_LIST_AUTO_REFRESH;
